import { CrmTranslateResources } from './crmTranslateCodes';

const translation: CrmTranslateResources = {
    CUSTOMER_FULL_NAME_REQUIRED: 'Customer full name is required',
    CUSTOMER_EMAIL_REQUIRED: 'Customer email is required'
};

export const en = {
    translation: translation
};